import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '@frontend/state';
import BarButton from '@components/bar-button';
import { check_that_user_subscription_is_valid } from '../../user_authentication';
import load_sketch_svg from '../../../assets/img/SVG_icons/Top/four_sketch/load_sketchesA.svg';
import { img } from '@phi/components';
import { IAuthentication } from '@phi/authentication/frontend';
import { display_sketch_images_modal } from '@frontend/reference_sketches';
import LoadSketchesTooltip from './LoadSketchesTooltip';
import { ISubscriptions } from '@phi/subscriptions/frontend';

export const LoadSketchIcon = load_sketch_svg;

export default defineComponent({
    props: {
        state: {
            required: true,
            type: Object as PropType<State>,
        },
        auth: { required: true, type: Object as PropType<IAuthentication> },
        subscriptions: { required: true, type: Object as PropType<ISubscriptions> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Import reference sketch';
        },

        disabled() {
            return !this.state.loaded;
        },
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else if (!check_that_user_subscription_is_valid())
                return;
            else if (this.subscriptions.state.subscription_status.value === 'starter' && this.state.imported_sketches.length > 0)
                this.subscriptions.show_pro_feature_modal();
            else
                display_sketch_images_modal();
        },
    },

    render() {
        return h(BarButton, {
            id: 'load-sketches-button',
            tippy: 'top',
            onClick: this.onClick,
            disabled: this.disabled,
            selected: this.state.tut_stage === 13,
            help: 'load_sketches',
            pro_indicator: (this.subscriptions.state.subscription_status.value === 'starter' && this.state.imported_sketches.length > 0),
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(load_sketch_svg, this.alt),
            tooltip: LoadSketchesTooltip,
        });
    },
});
